import { render, staticRenderFns } from "./OvertimeWasApproved.vue?vue&type=template&id=54649fc0"
import script from "./OvertimeWasApproved.vue?vue&type=script&lang=js"
export * from "./OvertimeWasApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports